import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { cssVar } from 'polished';

export const Tabs = styled.div`
  display: flex;
  border-bottom: solid 2px var(--tab-group-border);
  margin-bottom: 20px;
`;

export const Item = styled(Link)`
  display: flex;
  padding: 10px 15px;
  color: ${({ selected }) => cssVar(selected ? '--tab-group-active-color' : '--tab-group-color')};

  :active,
  :visited {
    color: ${({ selected }) => cssVar(selected ? '--tab-group-active-color' : '--tab-group-color')};
  }

  :hover {
    color: var(--tab-group-hover-color);
  }

  ::before,
  :active::before,
  :visited::before {
    background-color: var(--tab-group-active-color);
    height: 2px;
  }

  :hover::before {
    background-color: var(--tab-group-hover-color);
  }

  ${({ selected }) => selected && ':before { width: 100%; }'}
`;
